import { sendStructEvent } from '../../api';

interface PayloadModel {
    eventProperty: {
        store: number;
        orderID: string;
        userID: number;
    };
}

export const sendAddPaymentEvent = (payload: PayloadModel): void => {
    const { eventProperty } = payload;

    sendStructEvent({
        eventCategory: 'checkout',
        eventAction: 'addPaymentMethod',
        eventLabel: 'enter',
        eventProperty,
    });
};
